export default "__VITE_ASSET__C7rRHunV__"